<template>
    <div v-if="type === 'article'">
        <div
            v-if="model.cover_image"
            class="bg-cover bg-center"
            :class="$device.isMobile ? 'aspect-w-1 aspect-h-1' : 'aspect-w-16 aspect-h-5'"
            :style="`background-image: url(${$device.isMobile ? model.cover_image_cropped : model.cover_image})`"
        ></div>
        <div class="container pb-16 sm:pb-20 lg:pb-28">
            <div class="grid grid-cols-12">
                <section class="col-span-12 lg:col-span-8 lg:col-start-3">
                    <div class="page-header pt-8 sm:pt-12 lg:pt-16 mb-6 lg:mb-12">
                        <h1 class="heading-1 text-center">{{ model.title }}</h1>
                        <div
                            v-if="model.lead"
                            class="text-center mt-2 text-sm sm:text-base text-grey-500 w-full"
                            v-html="model.lead"
                        ></div>
                    </div>
                    <div class="tinymce-content" v-html="model.body"></div>
                </section>
            </div>

            <div v-if="bottomBannerData" class="col-span-12 my-12">
                <BannerCard
                    :title="bottomBannerData.public_title"
                    :label="bottomBannerData.surtitle"
                    :button-text="bottomBannerData.button_text"
                    :slug="bottomBannerData.button_url"
                    :desc="bottomBannerData.content"
                    :image="bottomBannerData.image"
                    :color="bottomBannerData.scheme"
                    :reversed="bottomBannerData.type"
                    class=""
                />
            </div>
        </div>
    </div>
    <div v-else class="container pb-16 sm:pb-20 lg:pb-28">
        <PageHeader :title="model.title" :subtitle="model.lead" class="mb-12 sm:mb-16" />

        <div class="grid grid-cols-12">
            <section class="col-span-12 lg:col-span-8 lg:col-start-3">
                <div class="tinymce-content" v-html="model.body"></div>
                <div v-if="model.downloads.length" class="grid grid-cols-6 gap-4 mt-8">
                    <div
                        v-for="(item, i) in model.downloads"
                        :key="`downloadable-${i}`"
                        class="col-span-6 sm:col-span-3"
                    >
                        <DownloadCard :url="item.url" :name="item.filename" :size="item.size" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import PageHeader from '../components/Generic/PageHeader/PageHeader';
import DownloadCard from '../components/Cards/DownloadCard/DownloadCard';
import BannerCard from '../components/Cards/BannerCard/BannerCard';

export default {
    name: 'ContentPage',
    components: {
        PageHeader,
        DownloadCard,
        BannerCard,
    },
    async asyncData({ params, $axios, error }) {
        let model = null;
        let type = null;

        try {
            await Promise.allSettled([
                $axios.$get(`/article/by-slug/${params.slug}`),
                $axios.$get(`/content/by-slug/${params.slug}`),
            ])
                .then(([articleRes, siteContentRes]) => {
                    if (articleRes.status === 'fulfilled' && articleRes.value.success === 1) {
                        model = articleRes.value.data;
                        type = 'article';
                    }

                    if (!model && siteContentRes.status === 'fulfilled' && siteContentRes.value.success === 1) {
                        model = siteContentRes.value.data;
                        type = 'content';
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        if (!model) {
            return error({ statusCode: 404, message: 'Page not found' });
        }

        return { model, type };
    },
    head() {
        const meta = [
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.model.title,
            },
            {
                hid: 'title',
                name: 'title',
                content: this.model.title,
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.model.lead,
            },
            {
                hid: 'description',
                name: 'description',
                content: this.model.lead,
            },
        ];

        if (this.type === 'article') {
            meta.push({
                hid: 'og:image',
                property: 'og:image',
                content: this.model.og_image,
            });
            meta.push({
                hid: 'og:image:url',
                property: 'og:image:url',
                content: this.model.og_image,
            });
        }

        return {
            title: this.model.title,
            meta,
        };
    },
    computed: {
        bottomBannerData() {
            return this.getPromotionBox('article-bottom');
        },
    },
};
</script>

<style scoped></style>
